import { CONNECTION_STATUS } from 'actions';
import { DOWNLOAD_FILE } from '../actions';

/**
 * Common reducer (some general actions)
 */
function common(state = {}, action) {
  switch (action.type) {
    case CONNECTION_STATUS:
      return {
        ...state,
        connectionInfo: action.connectionInfo,
        isOnline: action.isOnline,
        retries: action.retries
      };
    case DOWNLOAD_FILE:
      return {
        ...state,
        downloadedFilename: action.downloadedFilename
      };
    default:
      return state;
  }
}

export default common;
